var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "takeButtonModule"
  }, [_c('el-button', {
    ref: "liveBtn",
    class: _vm._f("BTNSTATUS")(_vm.showBtnStatus(_vm.currentSocektData)),
    attrs: {
      "type": "success",
      "disabled": _vm.showBtnStatus(_vm.currentSocektData) == 0 || _vm.timeLockPage && _vm.timeLocked || _vm.selectedROffline,
      "loading": _vm.allowClick,
      "title": _vm.$t(`${_vm.showBtnStatus(_vm.currentSocektData) == 2 ? 'lang.Stop' : _vm.parentComponent ? 'lang.goLive' : 'lang.Take'}`)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.startVideo();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(`${_vm.text}`)) + " ")]), _c('div', {
    staticClass: "hide"
  }, [_vm._t("default")], 2), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('lang.modelTips'),
      "visible": _vm.dialogVisible,
      "width": "30%",
      "custom-class": "greenColor"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(`${_vm.alertMessage}`)))]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.cancel')))]), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.Ok')))])], 1)]), _c('ShareConfirm', {
    attrs: {
      "show": _vm.showFlag
    },
    on: {
      "update:show": function ($event) {
        _vm.showFlag = $event;
      },
      "confirmFun": _vm.confirmFun
    }
  }), _vm.confirmObj.showFlag && _vm.openOnGoingEvent ? _c('GridDescription', {
    attrs: {
      "confirmObj": _vm.confirmObj
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }